import langUtil, { StringKey } from '@/utils/lang.util';

export const noLimitTime = -1;

export const itemList = {
  profile: 'profile',
  age: 'age',
  time: 'time',
  content: 'content',
  language: 'language',
  other: 'other',
};

export const ContentType = {
  Education: 'education',
  Music: 'music',
  Entertainment: 'entertainment',
  Mix: 'mix',
};
export const OtherTypes = {
  sound: 'sound',
  fullscreen: 'fullscreen',
  legal: 'legal',
  unsubscribe: 'unsubscribe',
  link: 'link',
};

export const LanguageCode = {
  English: 'en-US,en',
  French: 'fr-FR,fr',
  Spanish: 'es-ES,es',
  Portuguese: 'pt-PT,pt',
  Italian: 'it-IT,it',
  German: 'de-DE,de',
  Arabic: 'ar-AE,ar',
  Russian: 'ru-RU,ru',
};

const timeList = [5, 20, 40, 60, 90, langUtil.getLang().t(StringKey.SettingsNoLimit)];

const getAgeOptions = () => {
  return [ {
      display: 'settings_3_5_years',
      value: {
        minAge: 3,
        maxAge: 5
      },
      optionId: 1
    },
    {
      display: 'settings_6_8_years',
      value: {
        minAge: 6,
        maxAge: 8
      },
      optionId: 2
    },
    {
      display: 'settings_3_8 years',
      value: {
        minAge: 3,
        maxAge: 8
      },
      optionId: 3
    },
  ];
};

const convertedTimeOptions = (time) => {
  const displayTime = Number.isNaN(time) ? time : time + ' ' + langUtil.getLang().t(StringKey.MinutesShort);
  return displayTime;
};

const getTimeOptions = (timeL) => {
  const list = [];

  for (let i = 0; i < timeL.length; i += 1) {
    const convertedTime = convertedTimeOptions(timeL[i]);
    const intValue = Number.isNaN(Number(timeL[i])) ? noLimitTime : timeL[i];
    const option = { optionId: i, display: convertedTime, value: intValue };

    list.push(option);
  }

  return list;
};

export const contentOptions = [
  {
    optionId: 1,
    display: langUtil.getLang().t(StringKey.SettingsContentTypeMix),
    value: 0,
    img: null
  }, {
    optionId: 2,
    display: langUtil.getLang().t(StringKey.SettingsContentTypeFun),
    value: 1,
    img: require('@/assets/icons/Cartoon.svg')
  }, {
    optionId: 3,
    display: langUtil.getLang().t(StringKey.SettingsContentTypeLearn),
    value: 2,
    img: require('@/assets/icons/Education.svg')
  }, {
    optionId: 4,
    display: langUtil.getLang().t(StringKey.SettingsContentTypeMusic),
    value: 4,
    img: require('@/assets/icons/Music.svg')
  },
];

export const othersOptions = [
  {
    optionId: 1,
    display: langUtil.getLang().t(StringKey.SettingsMiscMusicSound),
    value: OtherTypes.sound,
    play: true,
  },
  {
    optionId: 2,
    display: langUtil.getLang().t(StringKey.SettingsMiscFullscreen),
    value: OtherTypes.fullscreen,
  },
  {
    optionId: 3,
    display: langUtil.getLang().t(StringKey.SettingsMiscGcu),
    value: OtherTypes.legal,
  },
  {
    optionId: 4,
    display: 'Account',
    type: 'link',
    value: OtherTypes.link,
  },
];

const languesOptions = [
  {
    optionId: 1,
    display: langUtil.getLang().t(StringKey.SettingsLanguageEnglish),
    value: 1,
    codeLang: LanguageCode.English,
  },
  {
    optionId: 2,
    display: langUtil.getLang().t(StringKey.SettingsLanguageSpanish),
    value: 27,
    codeLang: LanguageCode.Spanish,
  },
  {
    optionId: 3,
    display: langUtil.getLang().t(StringKey.SettingsLanguageFrench),
    value: 34,
    codeLang: LanguageCode.French,
  },
  {
    optionId: 4,
    display: langUtil.getLang().t(StringKey.SettingsLanguagePortuguese),
    value: 89,
    codeLang: LanguageCode.Portuguese,
  },
  {
    optionId: 5,
    display: langUtil.getLang().t(StringKey.SettingsLanguageItalian),
    value: 51,
    codeLang: LanguageCode.Italian,
  },
  {
    optionId: 6,
    display: langUtil.getLang().t(StringKey.SettingsLanguageGerman),
    value: 23,
    codeLang: LanguageCode.German,
  },
  {
    optionId: 7,
    display: langUtil.getLang().t(StringKey.SettingsLanguageArabic),
    value: 6,
    codeLang: LanguageCode.Arabic,
  },
  {
    optionId: 8,
    display: langUtil.getLang().t(StringKey.SettingsLanguageRussian),
    value: 94,
    codeLang: LanguageCode.Russian,
  },
];

const getItem = (itemType, title, list) => {
    const dataItem = { itemType, title, options: list };
    return dataItem;
};

export const settingList = [
  getItem(itemList.profile, '', []),
  getItem(itemList.age, langUtil.getLang().t(StringKey.SettingsAge), getAgeOptions()),
  getItem(itemList.time, langUtil.getLang().t(StringKey.SettingsTimeLimit), getTimeOptions(timeList)),
  getItem(itemList.content, langUtil.getLang().t(StringKey.SettingsContentType), contentOptions),
  getItem(itemList.language, langUtil.getLang().t(StringKey.SettingsLanguage), languesOptions),
  getItem(itemList.other, langUtil.getLang().t(StringKey.SettingsMisc), othersOptions),
];

const getSettingOptionList = () => settingList;

export default getSettingOptionList();
